import { computed } from 'vue'

import { useLocationStore } from '../store/location.store'

/**
 * The portal's customization document (AI-built portals), resolved once from portal settings.
 * `null` for every portal without one: callers then keep ClientPortal's default behaviour.
 */
export const usePortalCustomization = () => {
  const store = useLocationStore()
  return computed(() => store.customization)
}
